import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "toggle",
  "use": "toggle-usage",
  "viewBox": "0 0 49 26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 49 26\" id=\"toggle\"><g fill=\"none\"><rect width=\"48\" height=\"23\" x=\".5\" y=\"1.5\" fill=\"#FFF\" stroke=\"#FB6992\" rx=\"11.5\" /><rect width=\"26\" height=\"26\" x=\"23\" fill=\"#FB6992\" rx=\"13\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol